import BaseModel from '../BaseModel'
import ManagerModel from './ManagerModel'

export default class ManagersListModel extends BaseModel {
  constructor (data) {
    super()

    this.loop = this.loop.bind(this)
    this.loopWithKey = this.loopWithKey.bind(this)
    this.generateExpandedList = this.generateExpandedList.bind(this)
    this.fromTreeToList = this.fromTreeToList.bind(this)
    this.treeMapping = this.treeMapping.bind(this)

    if (Array.isArray(data)) {
      this.managersTree = this.treeMapping(data)
    } else {
      this.managersTree = this.treeMapping([data])
    }
    this.expandedManagersTree = this.fromTreeToList(this.managersTree)
  }

  generateExpandedList (data, list) {
    data.map(item => {
      let isLoaded = item.childrenNumber === item.children.length
      list.push({
        isLoaded,
        ...item
      })
      if (item.children) {
        this.generateExpandedList(item.children, list)
      }
    })
  }

  loop (data, newData) {
    data.map((item) => {
      let newItem = new ManagerModel(item)
      if (newItem.isActive) {
        newData.push(newItem)
        if (item.children && item.children.length > 0) {
          this.loop(item.children, newItem.children)
        }
      }
    })
  }

  fromTreeToList (data) {
    let list = []
    this.generateExpandedList(data, list)
    return list
  }

  treeMapping (data) {
    let newData = []
    this.loop(data, newData)
    return newData
  }

  loopWithKey (data, newData, key) {
    data.map((item) => {
      if (item.key === key) {
        item.children = [...newData]
      } else if (item.children && item.children.length > 0) {
        this.loopWithKey(item.children, newData, key)
      }
    })
  }

  mergeTrees (list, newList, currentKey) {
    if (!list || !newList) {
      return null
    }
    let data = [...list]
    this.loopWithKey(data, newList, currentKey)
    return data
  }
}



// WEBPACK FOOTER //
// ./src/api/managers/ManagersListModel.js